import { render } from "./ByTheNumbersSection.vue?vue&type=template&id=444e2d20&scoped=true"
const script = {}

import "./ByTheNumbersSection.vue?vue&type=style&index=0&id=444e2d20&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-444e2d20"]])

export default __exports__